import { render, staticRenderFns } from "./SystemNotification.vue?vue&type=template&id=0ab91b8e&scoped=true&"
import script from "./SystemNotification.vue?vue&type=script&lang=js&"
export * from "./SystemNotification.vue?vue&type=script&lang=js&"
import style0 from "./SystemNotification.vue?vue&type=style&index=0&id=0ab91b8e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab91b8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
